import * as React from 'react';
import { Portal as ReactPortal } from 'react-portal';

/**
 * #HACK: this DOM element needs to be passed as defaultProps,
 * to bypass react-portal's div creation
 *  */
// on render
export var Portal = function Portal(_ref) {
  var children = _ref.children,
      node = _ref.node;
  return /*#__PURE__*/React.createElement(ReactPortal, {
    node: node
  }, children);
};
Portal.displayName = 'Portal';